import React from "react";

/**  Lazy loading components for improved performance
*   React.lazy is used to dynamically import components when they are needed
*/

export const InstructorLogin = React.lazy(() => import("./Login/index.page"));
export const InstructorSignUp = React.lazy(() => import("./Signup/index.page"));
export const InstructorDashboard = React.lazy(() =>
    import("./Dashboard/index.page")
);
export const InstructorUserRequest = React.lazy(() =>
    import("./UserRequest/index.page")
);
export const InstructorAcceptedRequest = React.lazy(() =>
    import("./UserAcceptedRequest/index.page")
);
export const InstructorOtpVerification = React.lazy(() =>
    import("./OtpVerification/index.page")
);
